<div class="td-wb-holdings-di-table__sort-by">
  <label id="td-wb-holdings-di-table-change-sort-label"
         for="td-wb-holdings-di-table-change-sort"
         translate="tdWb.sortBySelector.LABEL"></label>
  @if (type === 'dropdown') {
    <td-wb-dropdown id="td-wb-holdings-di-table-change-sort"
                    class="td-wb-holdings-di-table__sort-by-dropdown"
                    name="td-wb-holdings-di-table-change-sort"
                    aria-labelledby="td-wb-holdings-di-table-change-sort-label"
                    [placeholder]="'tdWb.sortBySelector.PLEASE_SELECT' | tdWbTranslate"
                    [(ngModel)]="sortBy"
                    [panelMaxHeight]="panelMaxHeight"
                    [comparator]="comparator"
                    (ngModelChange)="onModelChange($event)">
      <td-wb-dropdown-toggle>
        <span [translate]="sortBy?.resourceKey"></span>
        <span class="td-wb-holdings-di-table__sort-by-direction"
              [translate]="'tdWb.sortBySelector.' + (sortBy?.direction  | uppercase)"></span>
      </td-wb-dropdown-toggle>
      @for (sortByOption of sortByOptions; track sortByOption) {
        <td-wb-dropdown-item [value]="sortByOption">
          <span [translate]="sortByOption.resourceKey"></span>
          <span class="td-wb-holdings-di-table__sort-by-direction"
                [translate]="'tdWb.sortBySelector.' + (sortByOption.direction | uppercase)"></span>
        </td-wb-dropdown-item>
      }
    </td-wb-dropdown>
  } @else {
    <td-wb-side-sheet-selector id="td-wb-holdings-di-table-change-sort"
                               class="td-wb-holdings-di-table__sort-by-dropdown"
                               name="td-wb-holdings-di-table-change-sort"
                               aria-labelledby="td-wb-holdings-di-table-change-sort-label"
                               [placeholder]="'tdWb.sortBySelector.PLEASE_SELECT' | tdWbTranslate"
                               [(ngModel)]="sortBy"
                               [panelMaxHeight]="panelMaxHeight"
                               [comparator]="comparator"
                               (ngModelChange)="onModelChange($event)">
      <td-wb-side-sheet-selector-toggle>
        <span [translate]="sortBy?.resourceKey"></span>
        <span class="td-wb-holdings-di-table__sort-by-direction"
              [translate]="'tdWb.sortBySelector.' + (sortBy?.direction  | uppercase)"></span>
      </td-wb-side-sheet-selector-toggle>
      @for (sortByOption of sortByOptions; track sortByOption) {
        <td-wb-side-sheet-selector-item [value]="sortByOption">
          <span [translate]="sortByOption.resourceKey"></span>
          <span class="td-wb-holdings-di-table__sort-by-direction"
                [translate]="'tdWb.sortBySelector.' + (sortByOption.direction | uppercase)"></span>
        </td-wb-side-sheet-selector-item>
      }
    </td-wb-side-sheet-selector>
  }


</div>
